const TRANSLATES = window.translations;

export const Translate = (key) => {
    return TRANSLATES ? TRANSLATES[key] : key;
};
